<template>
  <Container>
    <HeroText title="This is awkward." subtitle="Unfortunately, we can't offer you internet at your address :(" />
  </Container>

  <div class="bg-white">
    <Container>
      <Title class="pt-20 mb-4" title="How can we help?" :centered="true" id="contact"/>
      <HelpOptions class="pb-20" :features="contacts" />
    </Container>
  </div>
</template>

<script lang="ts" setup>
import Title from '../components/content/Title.vue';
import HeroText from '../components/content/HeroText.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const contacts = brandService.getContacts();

</script>
